/**
 * Utilitário centralizado para detecção de ambiente.
 * Usar SEMPRE este módulo em vez de checar import.meta.env diretamente.
 *
 * - isDevEnvironment(): true em localhost OU ambiente .dev.agendario.com.br
 * - isLocalhost(): true apenas em localhost
 * - isProduction(): true apenas no ambiente de produção (sem .dev.)
 */
import { authService } from '../services/authService';

export function isDevEnvironment() {
  return (
    import.meta.env.DEV ||
    import.meta.env.MODE === 'development' ||
    import.meta.env.VITE_API_URL?.includes('.dev.') ||
    window.location.hostname.includes('localhost') ||
    window.location.hostname.includes('.dev.')
  );
}

export function isLocalhost() {
  return (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  );
}

export function isProduction() {
  return !isDevEnvironment();
}

/**
 * Venda de planos (assinatura/cartão) fica OCULTA por padrão durante o go-live de pacotes (PIX).
 * Liga apenas com VITE_FEATURE_PLANS_SALE === 'true'. Default OFF (kill-switch da venda de planos).
 */
export function isPlansSaleEnabled() {
  return import.meta.env.VITE_FEATURE_PLANS_SALE === 'true';
}

/**
 * Admin do sistema (Blasoft) — MESMA definição do backend (API AdminOnlyHandler /
 * Login IsBlasoftAdmin): e-mail em domínio @blasoft.* ou na lista explícita.
 * Lê o claim `email` do JWT logado. Fail-closed: sem token/sem e-mail ⇒ false.
 * ⚠️ Gate de VISIBILIDADE (soft-launch), não de segurança — a autorização real
 * de endpoints admin continua na policy AdminOnly da API.
 */
export function isBlasoftAdminUser() {
  const email = authService.getUserInfo()?.email?.toLowerCase() ?? '';
  if (!email) return false;
  return (
    email === 'andremansur@gmail.com' ||
    email.endsWith('@blasoft.dev') ||
    email.endsWith('@blasoft.com.br')
  );
}

/**
 * Tela de Integrações (WhatsApp: config + vitrine de pacotes PIX + histórico).
 * O kill-switch é só de PRODUÇÃO: em DEV/localhost fica SEMPRE visível (para testar);
 * em PRD fica OCULTA por padrão e liga com VITE_FEATURE_INTEGRATIONS === 'true' (todos)
 * OU para admins Blasoft logados (teste interno em produção antes do go-live público).
 */
export function isIntegrationsEnabled() {
  return isDevEnvironment()
    || import.meta.env.VITE_FEATURE_INTEGRATIONS === 'true'
    || isBlasoftAdminUser();
}
